import Tables from 'src/class/Tables';
import i18n from '../../../../i18n';



const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: "name",
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: "type",
      label: i18n.t('common_words.type'),
      minWidth: 150,
      sortable: true,
    }
  ];
  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
